import { CategoryConfig } from './types';

export const PROMPTS = [
    "What workflow step just took longer than it should have?",
    "When did you have to work around the system instead of with it?",
    "What information was hard to find when you needed it quickly?",
    "Where did technology slow you down instead of helping?",
    "What did you have to explain or repeat multiple times?",
    "What decision felt unnecessarily complex due to poor design?",
    "When did handoffs feel awkward or incomplete?",
    "What clinical reasoning could benefit from AI support?",
    "Where did documentation take longer than patient care?",
    "What frustrated you most in the last hour?",
    "What worked surprisingly well and why?",
    "What would you change about this workflow if you could?",
    "When did poor interface design increase cognitive load?",
    "What safety issue emerged from systems design?",
    "Where could automation improve efficiency?",
    "What pattern are you noticing across multiple patients?",
    "When did you wish for better clinical decision support?",
    "What communication breakdown just occurred?",
    "Where did the EHR fail to match your mental model?",
    "What would make this process more human-centered?"
];

export const CATEGORIES: Record<string, CategoryConfig> = {
    workflow: {
        label: 'Workflow Issue',
        emoji: '🔄'
    },
    tech: {
        label: 'Tech Problem',
        emoji: '💻'
    },
    design: {
        label: 'Design Opportunity',
        emoji: '✨'
    },
    safety: {
        label: 'Safety Concern',
        emoji: '🛡️'
    }
}; 